export function getBranchesFetchDateSharedPrefs(): Promise<string | null> {
	return Promise.resolve(null)
}

export function saveBranchesFetchDateSharedPrefs(timestamp: string) {
	console.log('saveBranchesFetchDateSharedPrefs', timestamp)
}
